const jobFoundMethods = [
  {
    name: "Route 1: I found the job myself",
    value: "ROUTE_1",
  },
  {
    name: "Route 2: I found a job through an job opportunity that is communicated to me by Odyssea",
    value: "ROUTE_2",
  },
  {
    name: "Route 3: I found the job from a job interview that Odyssea arranged for me",
    value: "ROUTE_3",
  },
  {
    name: "Route 4: I improved my working conditions in the job that I had (upskilling)",
    value: "ROUTE_4",
  },
  {
    name: "Other",
    value: "OTHER",
  },
];

export default jobFoundMethods;
